<template>
    <v-card class="v-flex p-0" flat style="border-radius: unset; position: relative" @click="onClick"  >
        <div class="measure-name secondary white--text">
            <div>{{ name }}</div>
            <div v-if="hint" class="measure-hint">{{ hint }}</div>
        </div>
        <div class="measure-value secondary lighten-4 secondary--text">
            {{ measure }}
        </div>
    </v-card>
</template>

<script>

export default {
    name: "PLgsMeasureCard",

    props: {
        id: {

        },

        name: {

        },

        measure: {

        },

        hint: {

        }
    },

    methods: {
        onClick () {
            this.$emit("click", this.id)
        }
    }
}

</script>

<style scoped>

.measure-name {
    width: 50%;
    /* Reserves space for the optional hint line so cards with and without one are the same
       height within a group (only some LGS cards carry a hint). */
    min-height: 34px;
    text-align: left;
    padding-left: 10px;
    padding-top: 3px;
    font-size: 16px;
    border-bottom-left-radius: 6px;
    margin-right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}

.measure-hint {
    font-size: 11px;
    font-weight: 400;
    opacity: 0.85;
    line-height: 1.1;
}

.measure-value {
    width: 50%;
    text-align: center;
    padding-top: 6px;
    flex: 1 1 auto;
    font-size: 22px;
    font-weight: 600;
    border-bottom-left-radius: 6px!important;
    border-bottom-right-radius: 6px!important;
    display: flex;
    align-items: center;
    justify-content: center;
}


</style>